import { Theme } from '@typings/index'
import { Monitor, Moon, Sun } from 'lucide-react'

interface ThemeToggleProps {
  theme: Theme
  setTheme: (theme: Theme) => void
}

const ThemeToggle = ({ theme, setTheme }: ThemeToggleProps) => {
  return (
    <div className="flex items-center space-x-2 p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
      <button
        onClick={() => setTheme('light')}
        className={`p-2 rounded-lg ${theme === 'light' ? 'bg-white dark:bg-gray-700 shadow-sm' : ''}`}
      >
        <Sun size={20} />
      </button>
      <button
        onClick={() => setTheme('dark')}
        className={`p-2 rounded-lg ${theme === 'dark' ? 'bg-white dark:bg-gray-700 shadow-sm' : ''}`}
      >
        <Moon size={20} />
      </button>
      <button
        onClick={() => setTheme('system')}
        className={`p-2 rounded-lg ${theme === 'system' ? 'bg-white dark:bg-gray-700 shadow-sm' : ''}`}
      >
        <Monitor size={20} />
      </button>
    </div>
  )
}

export default ThemeToggle
